const monacoPath = `/monaco/vs`
// We use a version var for Monaco to bust browser caches. We need to bump this
// whenever we update the editor, pending a better solution.
const monacoVersion = "b054d0"

const loaderPath = `${monacoPath}/loader.js?version=${monacoVersion}`

let loaderPromise, editorPromise

/**
 * Load the Monaco editor from the server if it hasn't already been loaded.
 */
export default function loadMonaco() {
  return loadLoader().then(loadEditor)
}

function loadLoader() {
  if (!loaderPromise) {
    loaderPromise = new Promise(resolve => {
      const loaderScript = window.document.createElement("script")
      loaderScript.type = "text/javascript"
      loaderScript.src = loaderPath
      loaderScript.addEventListener("load", resolve)
      window.document.body.appendChild(loaderScript)
    })
  }

  return loaderPromise
}

function loadEditor() {
  if (!editorPromise) {
    editorPromise = new Promise(resolve => {
      window.require.config({ paths: { vs: monacoPath } })
      window.require(["vs/editor/editor.main"], resolve)
    })
  }

  return editorPromise
}
